import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
if ('serviceWorker' in navigator && !window.location.pathname.startsWith('/lehrerboard')) window.addEventListener('load', () => navigator.serviceWorker.register('/aufgaben/sw.js', { scope: '/aufgaben/' }).catch(() => undefined));
